export default {
  PageData: 0,
  Summary: 1,
};
